import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/projects')({
    component: ()=>/*#__PURE__*/ _jsx(Outlet, {})
});
